<template>
  <div>
    <router-view ref="route"></router-view>
    <p class="tip">以上填写信息将填充至税收居民身份声明文件中，请确保填写内容真实有效</p>
    <div class="button">
      <cube-button @click="submit">下一步</cube-button>
    </div>
  </div>
</template>


<script>
// import cmixin from '@/views/commonConfig';
import { mergeTxtInfoToDocs } from '@/api/tax';
import { createToast } from '@/utils';

export default {
  name: 'Tax',

  // mixins: [cmixin],

  async created() {
    const toast = this.$createToast({
      txt: '加载中...',
      type: 'loading',
      mask: true,
      time: 0,
    }).show();
    await this.$store.dispatch('getUserInfo');
    toast.hide();
  },

  methods: {
    // 提交表单
    async submit() {
      // 获取子页面的submit事件的参数
      const model = await this.$refs.route.submit();

      // 按接口要求处理数据
      const result = Object.entries(model).map(([key, value]) => {
        // 以 _ 开头的是选择框
        if (key.startsWith('_')) {
          return {
            key: value,
            labelType: 2,
            labelContent: '',
          };
        }
        return {
          key,
          labelType: 1,
          labelContent: value,
        };
      });

      const { investorUserInfo } = this.$store.state.tax;
      console.log(investorUserInfo);
      const params = {
        managerAdminUserId: investorUserInfo.managerId,
        investorUserId: investorUserInfo.invenstemUserId,
        platformUserId: investorUserInfo.platformUserId,
        investorTxtInfo: JSON.stringify(result),
      };
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      const response = await mergeTxtInfoToDocs(params, this.$store.getters.au);
      toast.hide();
      if (response.code === 0) {
        this.$bridge.callHandler('submitTxtFromSuccess');
      } else {
        createToast.call(this, response.msg);
      }
    },

  },

};
</script>

<style lang="scss" scoped>
.tip {
  padding: 8px 16px;
  font-size: 11px;
  line-height: 16px;
  color: #666666;
  background: #f5f5f5;
}
.button {
  padding: 10px 16px;
}
/deep/ {
  .radio-row .cube-radio {
    height: 46px;
  }
  .cube-form-group-legend:empty {
    padding: 0;
  }
  .cube-form-group-legend:not(:empty) {
    padding: 10px 15px;
    background: #fff;
    border-top: 12px solid #f5f5f5;
    border-bottom: 1px solid #E0E0E0;
    &::before {
      content: '';
      margin-right: 6px;
      display: inline-block;
      width: 5px;
      height: 16px;
      vertical-align: middle;
      background:#2E6BE6;
      border-radius: 2.5px;
    }
  }
}
</style>
